import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiClient } from '../services/authService';
import './ReportesErrores.css';

function ReportesErrores() {
  const [reportes, setReportes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [reporteEditando, setReporteEditando] = useState(null);
  const [comentario, setComentario] = useState('');

  useEffect(() => {
    cargarReportes();
  }, []);

  const cargarReportes = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get('/reportes/');
      setReportes(res.data);
    } catch (error) {
      console.error('Error al cargar reportes:', error);
    } finally {
      setLoading(false);
    }
  };

  const actualizarEstado = async (reporteId, nuevoEstado) => {
    try {
      await apiClient.put(`/reportes/${reporteId}`, {
        estado: nuevoEstado,
        comentario_admin: comentario || null
      });
      setReporteEditando(null);
      setComentario('');
      cargarReportes();
    } catch (error) {
      console.error('Error al actualizar reporte:', error);
      alert('Error updating report');
    }
  };

  const reportesFiltrados = filtroEstado === 'todos' 
    ? reportes 
    : reportes.filter(r => r.estado === filtroEstado);

  const tiposErrorLabels = {
    'respuesta_incorrecta': 'Incorrect answers',
    'error_ortografico': 'Spelling errors',
    'no_funciona': 'Not working correctly',
    'pregunta_confusa': 'Question is confusing',
    'otro': 'Other'
  };

  const estadosLabels = {
    'pendiente': 'Pending',
    'en_revision': 'Under review',
    'resuelto': 'Resolved',
    'rechazado': 'Rejected'
  };

  if (loading) {
    return <div className="reportes-loading">Loading reports...</div>;
  }

  return (
    <div className="reportes-wrapper">
      <div className="reportes-container">
      <div className="reportes-header">
        <h2>Error Reports</h2>
        <div className="reportes-filtros">
          <label>Filter by status:</label>
          <select 
            value={filtroEstado} 
            onChange={(e) => setFiltroEstado(e.target.value)}
          >
            <option value="todos">All status</option>
            <option value="pendiente">Pending</option>
            <option value="en_revision">Under review</option>
            <option value="resuelto">Resolved</option>
            <option value="rechazado">Rejected</option>
          </select>
        </div>
      </div>

      <div className="reportes-lista">
        {reportesFiltrados.length === 0 ? (
          <div className="sin-reportes">
            <p>No reports found with the selected filter.</p>
          </div>
        ) : (
          reportesFiltrados.map((reporte) => (
            <div key={reporte.id} className={`reporte-card reporte-${reporte.estado}`}>
              <div className="reporte-header">
                <div className="reporte-info">
                  <span className="reporte-id">Report #{reporte.id}</span>
                  <span className={`reporte-estado-badge estado-${reporte.estado}`}>
                    {estadosLabels[reporte.estado] || reporte.estado}
                  </span>
                </div>
                <span className="reporte-fecha">
                  {new Date(reporte.fecha_creacion).toLocaleDateString()}
                </span>
              </div>

              <div className="reporte-detalles">
                <div className="reporte-campo">
                  <strong>Question ID:</strong> {reporte.pregunta_id}
                  {reporte.numero_pregunta && ` (Question #${reporte.numero_pregunta})`}
                </div>
                <div className="reporte-campo">
                  <strong>Reported by:</strong> {reporte.usuario_username || 'Unknown'}
                </div>
                <div className="reporte-campo">
                  <strong>Error type:</strong> {tiposErrorLabels[reporte.tipo_error] || reporte.tipo_error}
                </div>
                <div className="reporte-campo">
                  <strong>Question text:</strong>
                  <div className="reporte-pregunta-texto">
                    {reporte.pregunta_texto || 'N/A'}
                  </div>
                </div>
                <div className="reporte-campo">
                  <strong>Description:</strong>
                  <div className="reporte-descripcion">
                    {reporte.descripcion}
                  </div>
                </div>
                {reporte.comentario_admin && (
                  <div className="reporte-campo">
                    <strong>Admin comment:</strong>
                    <div className="reporte-comentario-admin">
                      {reporte.comentario_admin}
                    </div>
                  </div>
                )}
              </div>

              {reporte.estado === 'pendiente' && (
                <div className="reporte-acciones">
                  {reporteEditando === reporte.id ? (
                    <div className="reporte-edicion">
                      <textarea
                        value={comentario}
                        onChange={(e) => setComentario(e.target.value)}
                        placeholder="Add admin comment (optional)..."
                        rows={3}
                      />
                      <div className="reporte-botones-edicion">
                        <button
                          onClick={() => {
                            setReporteEditando(null);
                            setComentario('');
                          }}
                          className="btn-cancelar-reporte"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => actualizarEstado(reporte.id, 'en_revision')}
                          className="btn-en-revision"
                        >
                          Mark as Under Review
                        </button>
                        <button
                          onClick={() => actualizarEstado(reporte.id, 'resuelto')}
                          className="btn-resolver"
                        >
                          Mark as Resolved
                        </button>
                        <button
                          onClick={() => actualizarEstado(reporte.id, 'rechazado')}
                          className="btn-rechazar"
                        >
                          Reject
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => setReporteEditando(reporte.id)}
                      className="btn-accion-reporte"
                    >
                      Update Status
                    </button>
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
      </div>
    </div>
  );
}

export default ReportesErrores;

